import { render } from "./idCardExample.vue?vue&type=template&id=5b1787a0"
import script from "./idCardExample.vue?vue&type=script&lang=js"
export * from "./idCardExample.vue?vue&type=script&lang=js"

import "./idCardExample.vue?vue&type=style&index=0&id=5b1787a0&lang=css"

import exportComponent from "C:\\Project\\VuePro\\guifanyuanyuanxing\\baiwenbida-index\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__